var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPadlock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 31.564,
    height: 42.086,
    viewBox: "0 0 31.564 42.086",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "padlock",
    d: "M30.619,15.782H29.3V10.521a10.521,10.521,0,0,0-21.043,0v5.261H6.946A3.95,3.95,0,0,0,3,19.728V38.14a3.95,3.95,0,0,0,3.946,3.946H30.619a3.95,3.95,0,0,0,3.946-3.946V19.728A3.95,3.95,0,0,0,30.619,15.782ZM11.768,10.521a7.014,7.014,0,1,1,14.029,0v5.261H11.768Zm8.768,18.8v3.995a1.754,1.754,0,1,1-3.507,0V29.323a3.507,3.507,0,1,1,3.507,0Z",
    transform: "translate(-3)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPadlock);
export default __webpack_public_path__ + "static/media/padlock.cf97bcf3.svg";
export { ForwardRef as ReactComponent };